import React, { useRef } from 'react'
import { useLeaflet, MarkerProps, Circle, Popup } from "react-leaflet";
import { eventToLatlng } from '../leaflet.helpers';
import _debounce from "lodash/debounce";

const noop = () => null

export interface IDraggableMarker extends MarkerProps {
    onChange?: (coords?: [number, number]) => void;
    onRemove?: () => void;
    renderContent?: (params: { removeMarker?: () => void; }) => any;
    style?: { [key: string]: any };
    className?: string;
}

const DraggableCircle: React.FC<IDraggableMarker> = ({
    onRemove,
    onChange = noop,
    renderContent,
    ...markerProps
}) => {
    const leaflet = useLeaflet()
    const map = leaflet.map

    const handleDragend = (e: any) => {
        const latlng = eventToLatlng(e)
        onChange([latlng.lat, latlng.lng])
    };


    const delayedOnChange = useRef(_debounce(handleDragend, 200));

    const _onMousedown = (event: any) => {
        if (map) {
            map.on('mousemove', function (e: any) {
                map.dragging.disable()
                event.target.setLatLng(e.latlng);
                delayedOnChange.current(e)
            });
            map.on('mouseup', function (e: any) {
                map.dragging.enable()
                map.removeEventListener('mousemove');
            });
        };
    }



    return (
        <Circle
            radius={40 * 1000}
            dashArray="1 6"
            weight={1}
            //@ts-ignore
            onDragend={handleDragend}
            onMousedown={_onMousedown}
            draggable
            autoPan
            {...markerProps}
        >
            {renderContent ? (
                renderContent({ removeMarker: onRemove })
            ) : onRemove ? (
                <Popup>
                    <a onClick={onRemove}>Poista sijainti</a>
                </Popup>
            ) : null}
        </Circle>

    )
}

export default DraggableCircle
